<template>
  <v-layout class="h-100 ma-0 pyramidParent">
    <v-flex md12>
      <v-card class="pyramid h-100">
        <v-card-text class="h-100">
          <transition name="fade-effect" mode="out-in">
            <skeleton-box v-if="isSearching || step < 1" key="skeleton-box" class="mt-3" :flat="true">
              <skeleton-line 
              class="skeleton-line-custom"
              style="width: 30vw"
              ></skeleton-line>
              <skeleton-line 
              class="skeleton-line-custom"
              style="width: 24vw"
              ></skeleton-line>
              <skeleton-line 
              class="skeleton-line-custom"
              style="width: 18vw"
              ></skeleton-line>
              <skeleton-line 
              class="skeleton-line-custom"
              style="width: 12vw"
              ></skeleton-line>
              <skeleton-line 
              class="skeleton-line-custom"
              style="width: 6vw"
              ></skeleton-line>
              
            </skeleton-box>
            <template v-else>
              <v-layout h-100 column>
                <v-flex md10>
                  <template v-if="data[0].value > 0 && data[1].value > 0">
                    <funnel :step="step"
                      @show-info="showScheduleInfo"
                      @update-step="$emit('update-step', $event)" key="funnel" height="400px" :data="data"/>
                  </template>
                  <template v-else-if="data[0].value > 0 && data[1].value < 1">
                    <v-layout  class="h-100 align-center text-xs-center">
                      <v-flex>
                        <span>
                          No se puede mostrar información en este momento
                        </span>
                      </v-flex>
                    </v-layout>
                  </template>
                  <template v-else>
                    <v-layout  class="h-100 align-center text-xs-center">
                      <v-flex>
                        <span>
                          No hay gestiones
                        </span>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-flex>
              </v-layout>
            </template>
          </transition>
          <actual-button :disabled="disabledActual" :filters="filters"></actual-button>
          <span class="caption font-weight-thin dateUpdate">
            {{date}}
          </span>
        </v-card-text>
      </v-card>
    </v-flex>
    
  </v-layout>
</template>
<script>
import moment from 'moment';
import SkeletonLine from '@/components/global/skeletons/Line';
import SkeletonBox from '@/components/global/skeletons/SkeletonBox';
import ActualButton from '../../ActualButton';
import Funnel from './Funnel';

export default {
  props: {
    isSearching: {
      type: Boolean,
      default: true,
    },
    filters: {
      type: Object,
      default: () => {},
    },
    date: {
      type: String,
      default: 'Buscando...',
    },
    step: {
      type: Number,
      default: 0,
    },
    data: {
      type: Array,
      required: true,
    },
  },
  components: {
    SkeletonLine,
    ActualButton,
    SkeletonBox,
    Funnel,
  },
  computed: {
    disabledActual() {
      return this.filters.date !== moment().format('YYYY-MM-DD');
    },
  },
  methods: {
    showScheduleInfo($event) {
      const obj = {};
      switch ($event) {
        case 'Clientes':
          obj.step = 'Clientes';
          obj.url = 'reports/funnel/clientes';
          break;
        case 'Gestionado':
          obj.step = 'Gestionado';
          obj.url = 'reports/funnel/gestionando';
          break;
        case 'Contactado':
          obj.step = 'Contactado';
          obj.url = 'reports/funnel/contactado';
          break;
        case 'Contacto útil':
          obj.step = 'Contacto útil';
          obj.url = 'reports/funnel/contacto-util';
          break;
        case 'Compromiso':
          obj.step = 'Compromiso';
          obj.url = 'reports/funnel/compromiso';
          break;
        default:
          break;
      }
      this.$emit('load-funnel-step', obj);
    },
  },
  watch: {
    'filters.date': {
      handler(val) {
        if (val !== moment().format('YYYY-MM-DD')) {
          this.filters.total_load = true;
        } else {
          this.filters.total_load = false;
        }
      },
    },
  },
};
</script>
<style scoped>
  .pyramid {
    width: 100%;
  }
  .skeleton-line-custom {
    height: 8vh !important;
    margin: auto;
    border-radius: 0 !important;
  }
  .dateUpdate {
    position: absolute;
    bottom: 2vh;  
    right: 1vw;
  }
</style>





// WEBPACK FOOTER //
// src/components/panelV2/ScheduleDaily/Schedule/Index.vue